import React, { Component, useState, useEffect, useCallback, useContext } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { ThemeContext } from '@emotion/core'
import Product from './Product'

import { Carousel } from 'react-responsive-carousel'
import useWindowWidth from '../../useWindowWidth'
import WindowWidthContext from '../../WindowWidthContext'

import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { carouselSection } from '../Carousel'

const Section = styled.section`
  margin-top: 2rem;
  margin-bottom: 4rem;

  padding: 0 4rem;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media (max-width: ${props => props.theme.breakpoints.xs}) {
    padding: 0;
  }
`

const CarouselSection = styled.section`
  ${carouselSection};
`

export default function List(props) {
  const { products } = props
  const theme = useContext(ThemeContext)
  const showSlider = useContext(WindowWidthContext) <= parseInt(theme.breakpoints.s, 10)

  return !showSlider ? (
    <Section>
      {products.map(product => (
        <Product key={product.id} slice={product.primary} />
      ))}
    </Section>
  ) : (
    <CarouselSection>
      <Carousel swipeScrollTolerance={100} showThumbs={false} showStatus={false} showArrows={false}>
        {products.map(product => (
          <Product key={product.id} slice={product.primary} />
        ))}
      </Carousel>
    </CarouselSection>
  )
}

List.propTypes = {
  products: PropTypes.array.isRequired,
}
